export function toError(error: unknown, defaultMessage = 'Unknown error') {
  if (error instanceof Error) return error;
  const message = typeof error === 'string' ? error : defaultMessage;
  return new Error(message, { cause: error });
}

export function enhanceError(error: unknown, context: Record<string, unknown>) {
  return Object.assign(toError(error), context);
}

type ErrorToJSON = (this: Error) => Record<string, unknown>;

export function makeErrorSerializable(error: Error & { toJSON?: ErrorToJSON }) {
  const originalToJSON: ErrorToJSON = error.toJSON ?? defaultErrorToJSON;
  const wrapped: ErrorToJSON = function () {
    const json = originalToJSON.call(error);
    // we want to include any own, enumerable properties of the error object
    // oxlint-disable-next-line typescript/no-misused-spread
    return { ...json, ...error };
  };
  Object.defineProperty(error, 'toJSON', {
    configurable: true,
    enumerable: false,
    writable: true,
    value: wrapped,
  });

  // `cause` may contain Errors as well
  if (error.cause instanceof Error) {
    makeErrorSerializable(error.cause);
  } else if (Array.isArray(error.cause)) {
    error.cause.forEach((o) => {
      if (o instanceof Error) {
        makeErrorSerializable(o);
      }
    });
  }
}

function defaultErrorToJSON(this: Error) {
  return {
    message: this.message,
    name: this.name,
    stack: this.stack,
    cause: this.cause,
  };
}
